import historyTabTemplate from '@/audit/layout/historyTabTemplate';

export default historyTabTemplate(['searches'], ({ search }) => search.audit, 'search');
